import React from "react"
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText
} from '@elastic/eui'


export default function softwareVideos() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="_-Bj91CZYLg"
                    title="Firmware and WebUI Update 1080p Series"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="Firmware and WebUI Update 1080p Series"
              footer={
                <EuiText>
                <p>Eine Einführung in die neue 1080p Web-Benutzeroberfläche für Ihre INSTAR Full HD Kamera.</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}




// import React from 'react'

// import { Player } from 'video-react'

// import {
//     EuiTitle,
//     EuiText,
//     EuiIcon,
//     EuiPanel
//   } from '@elastic/eui'

// import { OutboundLink } from 'gatsby-plugin-gtag'

// require('../../../../Layout/chrome/assets/video.css')

// function VideoCard() {
//   return (
//     <EuiPanel paddingSize="m">
//         <EuiTitle size="s"><h4>Firmware and WebUI Update 1080p Series</h4></EuiTitle>
//         <Player>
//         <source src="https://wiki.instar.com/videos/Vorstellung_der_neuen_FullHD_WebUI.mp4" />
//         </Player>
//         <EuiText>
//             <p>Eine Einführung in die neue 1080p Web-Benutzeroberfläche für Ihre INSTAR Full HD Kamera. Auf <OutboundLink href="https://www.youtube.com/watch?v=_-Bj91CZYLg" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
//         </EuiText>
//     </EuiPanel>
//   );
// }

// export default VideoCard